import * as actionsTypes from './../types/cartTypes'

export const addToCart = (item) => {
    return {
        type: actionsTypes.ADD_TO_CART,
        payload:{
            item: item,
        }
    }
}

export const removeFromCart = (guid) => {
    return {
        type: actionsTypes.REMOVE_FROM_CART,
        payload:{
            guid: guid,
        }
    }
}

export const adjustQty = (itemUID) => {
    return {
        type: actionsTypes.ADJUST_QTY,
        payload:{
            UID: itemUID,
        }
    }
}